export { BoxCompanyAboutWe } from './BoxCompanyAboutWe';
export { NavBar } from './NavBar';
export { SearchBar } from './SearchBar';
export { ListVacancies } from './ListVacancies';
export { Analytics, Gtm } from './Analytics';
export { RecommendationHeader } from './RecommendationHeader';
